import { useState } from "react";
import { Loader2, Save } from "lucide-react";
import { api } from "../../lib/api";

export default function AccountPanel({ me, onChanged }) {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState(null); // {ok, text}

  const submit = async (e) => {
    e.preventDefault();
    setMsg(null);
    if (next.length < 8) { setMsg({ ok: false, text: "New password must be at least 8 characters." }); return; }
    if (next !== confirm) { setMsg({ ok: false, text: "New passwords do not match." }); return; }
    setBusy(true);
    try {
      await api.changePassword(current, next);
      setMsg({ ok: true, text: "Password changed successfully." });
      setCurrent(""); setNext(""); setConfirm("");
      onChanged && onChanged();
    } catch (e2) {
      setMsg({ ok: false, text: e2.message });
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-md">
      {me.must_change_password && (
        <div className="mb-5 text-xs text-amber-300 bg-amber-400/10 border border-amber-400/20 rounded p-3">
          You are still using the initial password. Please set a new one.
        </div>
      )}
      <h3 className="text-white font-bold mb-1">Change password</h3>
      <p className="text-slate-500 text-xs mb-5">Signed in as {me.email}</p>

      <form onSubmit={submit}>
        <label className="block text-[11px] uppercase tracking-wide text-slate-500 mb-1">Current password</label>
        <input type="password" value={current} onChange={(e) => setCurrent(e.target.value)} required
          className="w-full mb-4 bg-[#0A0F2E] border border-white/10 focus:border-[#00F0FF]/50 rounded px-3 py-2 text-sm text-slate-100 outline-none" />

        <label className="block text-[11px] uppercase tracking-wide text-slate-500 mb-1">New password</label>
        <input type="password" value={next} onChange={(e) => setNext(e.target.value)} required
          className="w-full mb-4 bg-[#0A0F2E] border border-white/10 focus:border-[#00F0FF]/50 rounded px-3 py-2 text-sm text-slate-100 outline-none" />

        <label className="block text-[11px] uppercase tracking-wide text-slate-500 mb-1">Confirm new password</label>
        <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required
          className="w-full mb-4 bg-[#0A0F2E] border border-white/10 focus:border-[#00F0FF]/50 rounded px-3 py-2 text-sm text-slate-100 outline-none" />

        {msg && <p className={`text-xs mb-4 ${msg.ok ? "text-green-400" : "text-red-400"}`}>{msg.text}</p>}

        <button type="submit" disabled={busy} className="cyber-btn-primary py-2.5 px-6 flex items-center gap-2">
          {busy ? <Loader2 size={16} className="animate-spin" /> : <Save size={16} />} Update password
        </button>
      </form>
    </div>
  );
}
